













































































































































































































import tm_Attr from '@/components/other/tm-attr.vue';
import * as Util from '@/util.ts';
import * as Enums from '@/enums.ts';
import * as Constants from '@/constants.ts';
import firebase from 'firebase/app';
import Vue from 'vue';
import { setTimeout } from 'timers';

export default Vue.extend({
  components: {
    'tm-attr': tm_Attr,
  },
  data() {
    return {
      carouselKey: 0,
      showImages: this.$store.state.showImagesAutomatically,
      userOptedToSelectLessThanMax: {} as any,
      quantity: 1,
      currSelectedForGroup: {} as any,
      showSpecialRequestModal: false,
      specialRequest: '',
      attributes: Constants.FOOD_ATTRIBUTES,
    };
  },
  computed: {
    disableQuantityDown(): boolean {
      return this.$data.quantity <= (this.currentMenuItem.minimumQuantity || 1);
    },
    isViewOnlyMode(): boolean {
      return this.$store.state.appMode === Enums.eAppModes.viewOnly;
    },
    anAttributeIsDefined(): boolean {
      const attrs: any[] = [this.currentMenuItem.isHealthy, this.currentMenuItem.isAlcoholic, this.currentMenuItem.isVegetarian, this.currentMenuItem.isGlutenFree, this.currentMenuItem.isHalal, this.currentMenuItem.isKosher, this.currentMenuItem.isDairyFree, this.currentMenuItem.isPeanutFree, this.currentMenuItem.isSpicy];
      return attrs.some((el: any) => {
        return el !== null && el !== undefined && el !== false; // Might remove the last check here in the future if we want to show negative attributes as well.
      });
    },
    currentMenuItem(): MenuItem {
      return this.$store.state.currentMenuItem;
    },
    currentLocation(): EstablishmentLocation {
      return this.$store.state.currentLocation;
    },
    price(): string {
      return Util.formatCurrencyForMenuItem(this.currentMenuItem);
    },
  },
  watch: {
    currentMenuItem(newMenuItem: MenuItem) {
      this.$data.quantity = newMenuItem.minimumQuantity || 1;
    },
  },
  methods: {
    formatCurrency(price: number): string {
      return Util.formatCurrency(price, true);
    },
    reset() {
      this.$data.showImages = this.$store.state.showImagesAutomatically;
      this.$data.userOptedToSelectLessThanMax = {} as any;
      this.$data.quantity = 1;
      this.$data.currSelectedForGroup = {} as any;
      this.$data.specialRequest = '';
      this.currentMenuItem.combinedOptionGroups.forEach((og: OptionGroup) => {
        if (og.options) {
          og.options.forEach((op: Option) => {
            if (op.quantity) {
              op.quantity = 0;
            }
          });
        }
      });
    },
    initialize() {
      this.$data.carouselKey++;
    },
    capitalizeFirstLetter(str: string) {
      return Util.capitalizeFirstLetter(str);
    },
    optOutLabel(og: OptionGroup) {
      return this.$data.currSelectedForGroup[og.name] ? Util.t?.IJustWant.supplant([this.$data.currSelectedForGroup[og.name]]) : Util.t?.IDontWantAny;
    },
    onWebSearch() {
      window.open(`https://www.google.com/search?q=${this.currentMenuItem.name}`);
    },
    showChoiceOptOutTag(og: OptionGroup): boolean {
      const isUnbounded = og.canSelectMultipleOfSameOption && og.numberOfSelections === 0;
      return Boolean(!isUnbounded && og.numberOfSelections !== 0 && !og.mustPickExactAmount && (this.$data.currSelectedForGroup as any)[og.name] !== og.numberOfSelections);
    },
    showResetOptionGroupTag(og: OptionGroup): boolean {
      const atLeaseOneThingHasBeenPicked = Boolean(
        og.options?.some((option: Option) => {
          return option.quantity > 0;
        })
      );
      return og.canSelectMultipleOfSameOption && og.numberOfSelections !== 1 && atLeaseOneThingHasBeenPicked;
    },
    onShowImages() {
      this.$data.showImages = true;
    },
    selectOption(event: any, option: Option, optionGroup: OptionGroup) {
      if (option.isSoldOut) {
        Util.showError(Util.t?.optionSoldOut);
        return;
      }

      if (this.$store.state.appMode === Enums.eAppModes.viewOnly) {
        Util.showError(Util.t?.cannotMakeSelectionsInViewOnlyMode);
        return;
      }

      this.$data.userOptedToSelectLessThanMax[optionGroup.name] = false;

      // Make the quanitity for this option a number value.
      option.quantity = option.quantity || 0;

      // Create this to track the total number of option selected for this option group.
      let currSelectedForGroup: number = 0;

      optionGroup.options.forEach((el: any) => {
        currSelectedForGroup += el.quantity || 0;
      });

      if (optionGroup.numberOfSelections === 0 || currSelectedForGroup < optionGroup.numberOfSelections) {
        // We can select more options in this case.
        if (optionGroup.canSelectMultipleOfSameOption) {
          option.quantity++;
          currSelectedForGroup++;
        } else {
          if (option.quantity) {
            option.quantity = 0;
            currSelectedForGroup -= 1;
          } else {
            option.quantity = 1;
            currSelectedForGroup += 1;
          }
        }
      } else {
        // We cannot select more options in this case.
        if (!option.quantity) {
          // In this case the option we've selected hasn't been picked even once.
          if (optionGroup.numberOfSelections === 1) {
            // If you can only select one thing then unselect everything else and select this one.
            optionGroup.options.forEach((op) => {
              op.quantity = 0;
            });
            option.quantity = 1;
            currSelectedForGroup = 1;
          } else {
            // Otherwise if user tries to select a new option after hitting the max number of selections show this message.
            Util.showNotice(Util.t?.canOnlySelectMaxOptions.supplant([optionGroup.numberOfSelections]));
          }
        } else {
          currSelectedForGroup -= option.quantity;
          option.quantity = 0;
        }
      }

      if (option.quantity) {
        event.target.classList.add('selected');
      } else {
        event.target.classList.remove('selected');
      }

      (this.$data.currSelectedForGroup as any)[optionGroup.name] = currSelectedForGroup;
      this.$forceUpdate();
    },
    chooseText(og: OptionGroup): string {
      let ret = '';
      const numberOfSelections: string = og.numberOfSelections ? og.numberOfSelections.toString().toLowerCase() : '';
      if (numberOfSelections !== '1') {
        ret += og.mustPickExactAmount ? Util.t?.choose.supplant([numberOfSelections]) : numberOfSelections ? Util.t?.chooseUpTo.supplant([numberOfSelections]) : Util.t?.asManyAsYoudLike;
        ret += og.canSelectMultipleOfSameOption ? ' ' + Util.t?.multipleOfSingleOption : '';
      }
      return ret;
    },
    selectedOptions(): SelectedOptions {
      const ret: any = {};
      this.currentMenuItem.combinedOptionGroups.forEach((og: OptionGroup) => {
        const optsForCurrGroup: Option[] = [];
        if (og.options) {
          og.options.forEach((op: Option) => {
            if (op.quantity) {
              const opCopy = { ...op };
              optsForCurrGroup.push(opCopy);
            }
          });
        }
        ret[og.name] = optsForCurrGroup;
      });
      return ret;
    },
    addToOrder() {
      const onCanOrderConfirmed = () => {
        const newToBeSentOrders: OrderItem[] = [...this.$store.state.toBeSentOrders];
        const selectedOptions = this.selectedOptions();
        let totalPrice = this.currentMenuItem.price;

        if (!Util.isEmptyObject(selectedOptions)) {
          const arraryOfOptionArrays = Object.values(selectedOptions) as Option[][];
          arraryOfOptionArrays.forEach((arr: Option[]) => {
            arr.forEach((op: Option) => {
              totalPrice += op.priceChange;
            });
          });
        }

        const priceWithModifiers = totalPrice;
        totalPrice = totalPrice * this.$data.quantity;
        const totalPriceWithTax = Math.round(totalPrice * Util.getTaxRateFor(this.currentMenuItem));

        const orderToAdd: OrderItem = Util.removeFalsyExceptZero({
          orderItemId: Util.generateId(),
          quantity: this.$data.quantity,
          menuItemDocId: this.currentMenuItem.docId as string,
          menuItemName: this.currentMenuItem.name,
          totalPrice,
          priceWithModifiers,
          totalPriceWithTax,
          basePrice: this.currentMenuItem.price,
          specialRequest: this.$data.specialRequest,
          selectedOptions,
          dateCreated: Date.now(),
        } as OrderItem);

        newToBeSentOrders.push(orderToAdd);

        let valid = true;
        this.currentMenuItem.combinedOptionGroups.forEach((og: OptionGroup) => {
          const totalQuantityOfSelectedOptions = ((selectedOptions as any)[og.name] as Option[]).reduce((accumulator: number, o: Option): number => {
            return o.quantity ? accumulator + o.quantity : 0;
          }, 0);
          // If the option group has selections and they haven't picked as many as they can without opting to purposfully select less.
          if (og.numberOfSelections > 0 && totalQuantityOfSelectedOptions !== og.numberOfSelections && !this.$data.userOptedToSelectLessThanMax[og.name]) {
            valid = false;
            (this.$refs.optionGroups as Element).scrollIntoView();
            if (og.mustPickExactAmount) {
              Util.showError(Util.t?.mustChoose.supplant([og.numberOfSelections, og.name]));
            } else {
              Util.showError(Util.t?.mustChooseOrOptOut.supplant([og.numberOfSelections, og.name, this.optOutLabel(og)]));
            }
          }
        });
        if (valid) {
          Util.showSuccess(Util.t?.addedToYourOrder.supplant([this.currentMenuItem.name]));
          Util.setToBeSentOrders(newToBeSentOrders);
          Util.eventBus.$emit('closeAccordions');
          this.onCancel();
        }
      };

      if (this.currentMenuItem.isAlcoholic && this.$store.state.appMode !== Enums.eAppModes.takeout) {
        const drinkingAge: number = Util.getDrinkingAge();
        const highestConfirmedAge: number = this.$store.state.highestConfirmedAge;
        const isOverDrinkingAge: boolean = highestConfirmedAge >= drinkingAge;

        if (!isOverDrinkingAge) {
          Util.showConfirmation(Util.t?.itemIsAlcoholic, Util.t?.areYouOverYearsOld.supplant([drinkingAge]), () => {
            if (this.$store.state.currentClientUser) {
              Util.updateCurrentClientUser({
                settings: {
                  ...this.$store.state.currentClientUser,
                  highestConfirmedAge: drinkingAge,
                },
              });
            }
            onCanOrderConfirmed();
          });
        }
      } else {
        onCanOrderConfirmed();
      }
    },
    selectLessThanMax(og: OptionGroup) {
      this.$data.userOptedToSelectLessThanMax[og.name] = !this.$data.userOptedToSelectLessThanMax[og.name];
      this.$forceUpdate();
    },
    resetOptionGroup(og: OptionGroup) {
      og.options?.forEach((option: Option) => {
        option.quantity = 0;
      });
      (this.$data.currSelectedForGroup as any)[og.name] = 0;
      this.$forceUpdate();
    },
    onCancel() {
      this.$router.go(-1);
    },
  },
});
